import { createApp } from 'vue'
import { i18n } from '@/lang'
import { getCookie } from '@/helpers/base/cookie'
import { initTheme } from '@/helpers/base/theme'
import 'regenerator-runtime'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import router from './router'
import App from './App.vue'

initTheme()

const jwt = getCookie('jwt')
if (jwt) store.commit('userInfo/setJwt', jwt)

const app = createApp(App)

app.use(store)
app.use(router)
app.use(i18n)

app.mount('#app')
